import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { listNameExists } from "../lib/listNameExists";
import { UserAuth } from "../Context";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { saveShoppingListToAlgolia } from "../lib/algoliaFunctions";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import LoadingSpinner from "../UserProfile/LoadingSpinner";

const RenameModal = ({ BackgroundOnSvg, list, closeOtherDropdown }) => {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState(list?.name);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(name === list?.name);
  const [error, setError] = useState("");
  const { user } = UserAuth();
  const closeModal = () => {
    setName(isDisabled ? list?.name : name);
    setShowModal(false);
  };
  const handleRename = async () => {
    setLoading(true);
    if ((await listNameExists(user, name)) === true) {
      setError("List name already exists");
      //   setName(list?.name);
      setIsDisabled(true);
      setLoading(false);
      return;
    }
    const listRef = doc(db, "users", user?.uid, "shoppingList", list?.id);
    await updateDoc(listRef, { listName: name });
    closeModal();
    if (list?.visibility === "Public")
      saveShoppingListToAlgolia(user, list?.id);
    setLoading(false);
  };

  return (
    <>
      <div
        onClick={() => {
          setShowModal(true);
          closeOtherDropdown();
        }}
        className="d-flex align-items-center"
        style={{ gap: "12px" }}
      >
        <BackgroundOnSvg>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.39289 1.42859C8.09703 1.42859 7.85718 1.66844 7.85718 1.9643C7.85718 2.26017 8.09703 2.50002 8.39289 2.50002H9.46432V17.5H8.39289C8.09703 17.5 7.85718 17.7399 7.85718 18.0357C7.85718 18.3316 8.09703 18.5714 8.39289 18.5714H11.6072C11.903 18.5714 12.1429 18.3316 12.1429 18.0357C12.1429 17.7399 11.903 17.5 11.6072 17.5H10.5357V2.50002H11.6072C11.903 2.50002 12.1429 2.26017 12.1429 1.9643C12.1429 1.66844 11.903 1.42859 11.6072 1.42859H8.39289Z"
              fill="#676A79"
            />
            <path
              d="M4.46425 4.29968H8.74996V5.37111H4.46425C3.77389 5.37111 3.21425 5.93075 3.21425 6.62111V13.4068C3.21425 14.0972 3.77389 14.6568 4.46425 14.6568H8.74996V15.7283H4.46425C3.18216 15.7283 2.14282 14.6889 2.14282 13.4068V6.62111C2.14282 5.33902 3.18216 4.29968 4.46425 4.29968Z"
              fill="#676A79"
            />
            <path
              d="M15.5357 14.6568H11.25V15.7283H15.5357C16.8178 15.7283 17.8571 14.6889 17.8571 13.4068V6.62111C17.8571 5.33902 16.8178 4.29968 15.5357 4.29968H11.25V5.37111H15.5357C16.2261 5.37111 16.7857 5.93075 16.7857 6.62111V13.4068C16.7857 14.0972 16.2261 14.6568 15.5357 14.6568Z"
              fill="#676A79"
            />
          </svg>
        </BackgroundOnSvg>
        <span
          style={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "100%",
            letterSpacing: "0px",
          }}
        >
          Rename List
        </span>
      </div>
      <Modal
        show={showModal}
        centered
        onHide={closeModal}
        className="renameModal"
      >
        <style jsx>
          {`
            .renameModal .modal-content {
              box-shadow: 0 0.5rem 1rem rgba(83, 88, 93, 0.25) !important;
              border-radius: 20px !important;
              max-height: 576px;
            }

            .renameModal .modal-dialog {
              max-width: 600px;
              margin: 1rem auto; /* Add some margin */
            }

            .inputField {
              height: 46px;
              padding: 5px 16px;
              position: relative;
            }

            .input-textbox {
              height: 46px;
              border-radius: 12px;
              border-width: 0.86px;
              padding: 6px 12px;
              border: 0.86px solid #c3c3c3;
              font-size: 14px;
              //   color: #676a79;
              width: 100%;
            }

            .renameModalbuttonStyle {
              height: 56px;
              border-radius: 12px;
              padding: 0px 16px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .buttonTextStyle {
              font-family: Inter;
              font-weight: 400;
              font-size: 18px;
              line-height: 100%;
              letter-spacing: 2%;
              text-align: center;
            }
          `}
        </style>

        <Modal.Body style={{ padding: "40px " }}>
          <div className="d-flex flex-column" style={{ gap: "32px" }}>
            <div className="d-flex w-100 justify-content-between">
              <div
                style={{
                  fontFamily: "Inter",
                  color: "#101828",
                  fontWeight: "600",
                  fontSize: "24px",
                  lineHeight: "24px",
                  letterSpacing: "0%",
                }}
              >
                Rename Shopping List
              </div>
              <button
                type="button"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "27px",
                  height: "27px",
                  background: "#FFFFFF",
                  border: "1px solid #FF3B30",
                  boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                  borderRadius: "25px",
                  flex: "none",
                  order: "1",
                  flexGrow: "0",
                }}
                onClick={closeModal}
              >
                <svg
                  style={{ width: "11px" }}
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#FF3B30"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="d-flex flex-column" style={{ gap: "24px" }}>
              <div
                style={{
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "18px",
                  lineHeight: "20px",
                  letterSpacing: "0%",
                }}
              >
                Update the name of your shopping list to better reflect its
                purpose.
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (!isDisabled) handleRename();
                }}
                className="d-flex flex-column"
                style={{ gap: "24px" }}
              >
                <div>
                  <input
                    type="text"
                    id="searchInput"
                    className="input-textbox"
                    placeholder="Search"
                    value={name}
                    onChange={(e) => {
                      setIsDisabled(false);
                      setName(e.target.value);
                      setError("");
                      if (list?.name === e.target.value) {
                        setIsDisabled(true);
                      } else if (e.target.value.length === 0) {
                        setIsDisabled(true);
                      } else if (/^\d+$/.test(e.target.value)) {
                        setError("List name cannot be completely numeric");
                      } else if (
                        /[!@#$%^&*,.?":{}|<>\=+\;()/\\[\]]/.test(e.target.value)
                      ) {
                        setError("List name cannot contain special characters");
                      }
                    }}
                  />
                  {error && <div className="text-danger mt-2">{error}</div>}
                </div>
                <div className="d-flex flex-column" style={{ gap: "8px" }}>
                  <button
                    type="submit"
                    className="renameModalbuttonStyle border-0"
                    // onClick={isDisabled ? null : handleRename}
                    style={{
                      backgroundColor: isDisabled ? "#cecece" : "#005FDA",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      className="buttonTextStyle"
                      style={{ color: isDisabled ? "#3e3e3e" : "white" }}
                    >
                      {loading ? <LoadingSpinner /> : "Update"}
                    </div>
                  </button>
                  <div
                    className="renameModalbuttonStyle"
                    onClick={closeModal}
                    style={{ backgroundColor: "#E4E9EF", cursor: "pointer" }}
                  >
                    <div
                      className="buttonTextStyle"
                      style={{ color: "#005FDA" }}
                    >
                      Cancel
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RenameModal;
